import { useTranslations } from "next-intl"
import Heading from "../Heading"
import { Button } from "@/components/shared/ui/button"
import Questions from "./Questions"
import { questions } from "@/constants/question"
import { Link } from "@/navigation"
import { MessageCircleQuestion } from "lucide-react"

const CommonQuestions = () => {
    const t = useTranslations("Home.common-questions")

    return (
        <section className="w-full max-w-7xl mx-auto px-4 py-16 md:py-24">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
                {/* Left Section - Title and Contact */}
                <div className="flex flex-col items-center lg:sticky lg:top-24 lg:w-1/3">
                    <div className="flex items-center gap-3 mb-6">
                        <MessageCircleQuestion className="w-8 h-8 text-secondary" />
                        <div className="text-left">
                            <Heading 
                                id="common" 
                                title={t("title")} 
                                subTitle={t('subTitle')} 
                            />
                        </div>
                    </div>
                    
                    <Link href='/contact'>
                        <Button 
                            variant='secondary' 
                            size="lg" 
                            className="rounded-full py-6 px-8 text-white hover:scale-105 transition-transform duration-300"
                        >
                            {t("contact")}
                        </Button>
                    </Link>
                </div>

                {/* Right Section - Questions */}
                <div className="w-full lg:w-2/3">
                    <div className="bg-white rounded-2xl shadow-soft p-6 md:p-8">
                        <Questions questions={questions} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CommonQuestions